

















import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';

import Popover from '@/components/common/popover.vue';

@Component({
  components: {
    Icon,
    Popover,
  },
})
export default class PhoneLink extends Vue {
  isShown = false;
}
